// extracted by mini-css-extract-plugin
module.exports = {"main":"DefaultTemplate_main__wplH_","content":"DefaultTemplate_content__OZCMy","slide-down":"DefaultTemplate_slide-down__NEY8K","slide-up":"DefaultTemplate_slide-up__TCKXE"};